import styled from 'styled-components';

export const List = styled.ul`
 display: flex;
 flex-direction: column;
 gap: 20px;
`;

export const HomeworkSection = styled.div`
  margin-bottom: 100px;
  padding: 20px;
  border-top: 1px solid #e0e0e0;
  background-color: #f5f5f5;
  border-radius: 0 0 8px 8px;
`;

export const HomeworkText = styled.pre`
  font-family: Raleway;
  font-size: 16px;
  color: #333333;
  background-color: #ffffff;
  padding: 15px;
  border-radius: 8px;
  white-space: pre-wrap; 
  word-wrap: break-word; 
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const Actions = styled.div`
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
`;

export const Button = styled.button`
  font-family: Raleway;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  background-color: #4CAF50;
  color: white;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;

  &:hover {
    background-color: #45a049;
    transform: translateY(-2px);
  }

  &:active {
    background-color: #3e8e41;
  }
`;

export const RejectButton = styled(Button)`
  background-color: #e74c3c;

  &:hover {
    background-color: #c0392b;
  }

  &:active {
    background-color: #a93226;
  }
`;

// 🆕 — превью изображений в сетке
export const ImagesGrid = styled.div`
  margin-top: 15px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
`;

export const ImagePreview = styled.img`
  width: 100%;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

// 🌙 Затемнённый фон с анимацией появления
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.25s ease;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

// 🖼️ Контейнер для картинки — аккуратно центрирован
export const ModalContent = styled.div`
  position: relative;
  max-width: 100vw;
  max-height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000;
  padding: 5px;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.6);
  overflow: hidden;
`;

// 📸 Само изображение — без скроллов, адаптируется
export const ModalImage = styled.img`
  max-width: 100%;
  max-height: 85vh;
  object-fit: contain;
  border-radius: 8px;
  display: block;
`;

// ❌ Кнопка закрытия — снаружи, но по центру верхнего угла
export const CloseButton = styled.button`
  position: absolute;
  top: 2px;
  right: 2px;
  background-color: #fff;
  color: #000;
  border: none;
  font-size: 22px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.4);
  transition: background-color 0.2s ease;
  z-index: 1010;
  &:hover {
    background-color: #f2f2f2;
  }
`;
